import React from "react";
import { Route, Routes } from "react-router-dom";
import { Blog } from "../pages/Blog";
import { Channels } from "../pages/Channels";
import FacebookPage from "../pages/FacebookPage";
import Home from "../pages/Home";
import InstagramPage from "../pages/InstagramPage";
import LinkedinPage from "../pages/LinkedinPage";
import Login from "../pages/Login";
import PrivateRoute from "./PrivateRoute";
import { Publishing } from "../pages/Publishing";
import Register from "../pages/Register";
import Admin from "../pages/Admin";
import AdminPrivateRoute from "./AdminPrivateRoute";
import PricingPage from "../pages/PricingPage";

export const Mainroute = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/blogs" element={<Blog />} />
        <Route
          path="/admin"
          element={
            <AdminPrivateRoute>
              <Admin />
            </AdminPrivateRoute>
          }
        />
        {/* <Route
          path="/admin/users"
          element={
            <AdminPrivateRoute>
              <UserList />
            </AdminPrivateRoute>
          }
        />
        <Route
          path="/admin/posts"
          element={
            <AdminPrivateRoute>
              <PostList />
            </AdminPrivateRoute>
          }
        /> */}
        <Route
          path="/publishing"
          element={
            <PrivateRoute>
              <Publishing />
            </PrivateRoute>
          }
        />
        <Route
          path="/facebook"
          element={
            <PrivateRoute>
              <FacebookPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/instagram"
          element={
            <PrivateRoute>
              <InstagramPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/linkedin"
          element={
            <PrivateRoute>
              <LinkedinPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/channels"
          element={
            <PrivateRoute>
              <Channels />
            </PrivateRoute>
          }
        />
        <Route path="/publishing" element={<Publishing />} />
      </Routes>
    </>
  );
};
